import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: unknown): void {
    const message = this.getErrorMessage(error);

    if (this.isChunkLoadError(message)) {
      this.handleChunkLoadError();
      return;
    }

    // Keep normal Angular errors visible
    console.error(error);
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  }

  private isChunkLoadError(message: string): boolean {
    return (
      /Failed to fetch dynamically imported module/i.test(message) ||
      /error loading dynamically imported module/i.test(message) ||
      /Loading chunk .* failed/i.test(message) ||
      /Importing a module script failed/i.test(message) ||
      /ChunkLoadError/i.test(message)
    );
  }

  private handleChunkLoadError(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const reloadKey = 'orgapp_chunk_reload';
    const now = Date.now();
    const previousReload = sessionStorage.getItem(reloadKey);

    // Prevent infinite reload loops.
    if (
      previousReload &&
      now - Number(previousReload) < 30_000
    ) {
      console.error(
        'Lazy-loaded chunk failed after reload. Stopping reload loop.'
      );
      return;
    }

    sessionStorage.setItem(reloadKey, String(now));

    window.location.reload();
  }
}